<template>
    <div class="counter">
        <a
            @click.prevent="decrement"
            class="counter__btn counter__btn--minus"
            href="#"
            :class="{disabled : isDecrementDisabled}"
        ></a>

        <input class="counter__input" min="1" step="1" type="number" v-model="valueHolder"/>

        <a
            @click.prevent="increment"
            class="counter__btn counter__btn--plus"
            href="#"
            :class="{disabled : isIncrementDisabled}"
            :title="incMessage"
        ></a>

    </div>
</template>

<script>
export default {
    data: function () {
        return {
            internalValue: 0,
            oldValue: 0,
            timeout: null,
            timeoutOvergrow: null
        };
    },
    props: {
        value: {},
        allowZero: {},
        maxValue: {},
        allowOvergrow: {
            type: Boolean,
            default: true
        },
        useMaxValue: {
            type: Boolean,
            default: false
        },
        incrementMessage: {
            type: String,
            default: ''
        }
    },
    computed: {
        isDecrementDisabled: function () {
            return this.valueHolder < 2;
        },
        isIncrementDisabled: function () {
            return this.useMaxValue && this.maxValue <= this.valueHolder && !this.allowOvergrow;
        },
        incMessage: function() {
            return this.incrementMessage !== '' && this.isIncrementDisabled ? this.incrementMessage : '';
        },
        valueHolder: {
            get: function () {
                return this.internalValue;
            },
            set: function (value) {
                var vm = this;
                if (this.timeoutOvergrow) {
                    clearTimeout(this.timeoutOvergrow);
                }
                if ((value < 1 || !Number.isInteger(value)) && !this.allowZero) {
                    value = 1;
                }
                if (this.useMaxValue && this.maxValue < value && !this.allowOvergrow) {
                    this.timeoutOvergrow = setTimeout(() => {
                        vm.$emit("overgrow");
                    }, 1000);
                    value = this.maxValue;
                }
                this.internalValue = value - 1;
                this.internalValue = value;
                if (this.timeout) {
                    clearTimeout(this.timeout);
                }

                this.timeout = setTimeout(() => {
                    vm.$emit("input", value);
                    vm.timeout = null;
                }, 1000);
                vm.$emit('change');
            }
        }
    },
    watch: {
        value: function (newVal, oldVal) {
            this.internalValue = parseInt(newVal);
            this.oldValue = parseInt(newVal);
        }
    },
    methods: {
        increment: function () {
            if ((this.useMaxValue && this.valueHolder <= this.maxValue) || !this.useMaxValue || this.allowOvergrow) {
                this.valueHolder += 1;
            }
        },

        decrement: function () {
            if (this.valueHolder === 1 && !this.allowZero) {
                return;
            }
            this.valueHolder -= 1;
        },
    },

    created: function () {
        this.internalValue = parseInt(this.value);
        this.oldValue = parseInt(this.value);
    }
};
</script>
